import WebServiceConnector from '../connector/WebServiceConnector'
import Vue from 'vue'
import router from '../router'
import uuidv1 from 'uuid/v1'

export default {
  namespaced: true,
  state: {
    userInfo: {},
    sessionId: null
  },
  getters: {
    getSessionId (state) {
      return state.sessionId
    },
    getWebServiceConnector (state) {
      const token = state.userInfo.authToken
      const connector = new WebServiceConnector((e) => {
        if (e.message === 'Unauthorized') {
          router.replace({ path: '/login' })
        }
        // else if (e.message) {
        //   Vue.toasted.global.web_service_error({ message: e.message })
        // } else {
        //   Vue.toasted.global.web_service_error()
        // }
      })
      if (token) {
        connector.setNewToken(token)
      }
      return connector
    },
    getUserDetail (state) {
      return state.userInfo
    },
    getName (state) {
      return state.userInfo.name
    },
    getEmail (state) {
      return state.userInfo.email
    },
    getPhone (state) {
      return state.userInfo.phone
    },
    getProfilePicture (state) {
      return state.userInfo.profilePicture
    },
    getUserId (state) {
      return state.userInfo.userId
    },
    getIsLdapUser (state) {
      return state.userInfo.isLdapUser
    },
    isAuthenticate (state) {
      return !!(state.userInfo && state.userInfo.authToken)
    }
  },
  actions: {
    async login (context, { email, password }) {
      const webServiceConnector = context.getters.getWebServiceConnector
      const userInfo = await webServiceConnector.login(email, password)
      context.commit('setUserDetail', userInfo)
      return userInfo
    },
    async refresh (context) {
      const webServiceConnector = context.getters.getWebServiceConnector
      const newTokenData = await webServiceConnector.refreshToken()
      if (newTokenData) {
        context.commit('setNewToken', newTokenData)
      }
    },
    async logout (context) {
      context.commit('removeUserDetail')
    },
    async register (context, { name, email, password }) {
      const webServiceConnector = context.getters.getWebServiceConnector
      return webServiceConnector.register(name, email, password)
    },
    async updateUser (context, userInfo) {
      const webServiceConnector = context.getters.getWebServiceConnector
      const newUserInfo = await webServiceConnector.updateUserInfo(userInfo)
      if (newUserInfo) {
        context.commit('updateUserDetail', newUserInfo)
      }
      return newUserInfo
    },
    async updatePassword (context, newPasswordData) {
      const webServiceConnector = context.getters.getWebServiceConnector
      return webServiceConnector.updatePassword(newPasswordData)
    },
    generateSessionId (context) {
      const newSessionId = uuidv1()
      console.log('GENERATE ' + newSessionId)
      context.commit('setSessionId', newSessionId)
    },
    verifyEmail (context, params) {
      const webServiceConnector = context.getters.getWebServiceConnector
      return webServiceConnector.verifyEmail(params)
    },
    forgotPassword (context, email) {
      const webServiceConnector = context.getters.getWebServiceConnector
      return webServiceConnector.forgotPassword(email)
    },
    resetPassword (context, { newPassword, token, source }) {
      const webServiceConnector = context.getters.getWebServiceConnector
      return webServiceConnector.resetPassword(newPassword, token, source)
    },
    trackCustomEvent (context, { event = null, action, target, linkTo = null, label = 'console', value = null, amount = null }) {
      // window.onePalette.emitEvent(event || action, {
      //   action: action,
      //   target: target,
      //   linkTo: linkTo,
      //   label: label,
      //   value: value,
      //   amount: amount
      // })
    }

  },
  mutations: {
    setUserDetail (state, data) {
      state.userInfo = data
    },
    setNewToken (state, data) {
      Vue.set(state.userInfo, 'authToken', data.authToken)
      Vue.set(state.userInfo, 'authTokenExpireAt', data.authTokenExpireAt)
    },
    removeUserDetail (state) {
      state.userInfo = {}
    },
    updateUserDetail (state, data) {
      Vue.set(state.userInfo, 'name', data.info.name)
      Vue.set(state.userInfo, 'phone', data.info.phone)
      Vue.set(state.userInfo, 'profilePicture', data.profilePicture)
    },
    setSessionId (state, data) {
      state.sessionId = data
    }
  }
}
